// Slots del Social Outlet: fetch + normalización. Compartido por SlotPicker
// (pantalla de selección) y RegistrationForm (horarios de interés en la fila).

const ODOO_PRIMARY_URL = 'https://odoo.core.daisies.mx/odoo-firebase-core/odoo-import';
const ACCESS_TOKEN = process.env.REACT_APP_ACCESS_TOKEN || 'adc6b57347275d84196366a03ac4d288f8c79eae1c24e5e5992f28044789b679';

/* Solo se incluyen las especialidades cubiertas por la membresía social.
   Las de alta especialidad (p.ej. Endocrinología) se excluyen del listado. */
const SPECIALTY_STYLES = {
  'Psicología':       { id: 16, durationId: 109, emoji: '💭', color: '#F0EEFB', accent: '#786ED9' },
  'Ginecología':      { id: 15, durationId: 108, emoji: '🌸', color: '#FFF1F2', accent: '#E11D48' },
  'Nutrición':        { id: 17, durationId: 111, emoji: '🥗', color: '#F0FDF4', accent: '#16A34A' },
  'Salud General':    { id: 18, durationId: 113, emoji: '🩺', color: '#EFF6FF', accent: '#2563EB' },
  'Medicina General': { id: 18, durationId: 113, emoji: '🩺', color: '#EFF6FF', accent: '#2563EB' },
  'Entrenamiento':    { id: 21, durationId: 120, emoji: '💪', color: '#FFF7ED', accent: '#EA580C' },
};

const ALLOWED_SPECIALTY_IDS = new Set([15, 16, 17, 18, 21]);

function getSpecialtyStyle(name) {
  return SPECIALTY_STYLES[name] || null;
}

function isAllowedSpecialty(professional) {
  if (ALLOWED_SPECIALTY_IDS.has(professional.specialty_id)) return true;
  return Boolean(SPECIALTY_STYLES[professional.specialty_name]);
}

export async function fetchOutletSlots() {
  try {
    const res = await fetch(ODOO_PRIMARY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        params: {
          access_token: ACCESS_TOKEN,
          account_id: 1,
          res_id: 1,
          res_model: 'dais.consultation',
          res_method: 'get_social_outlet_slots',
          res_params: {
            tz: 'America/Mexico_City',
          },
        },
      }),
    });
    const data = await res.json();
    if (data?.result?.success) {
      return {
        slots: Array.isArray(data.result.slots) ? data.result.slots : [],
        upcoming: Array.isArray(data.result.upcoming) ? data.result.upcoming : [],
      };
    }
    console.warn('[slotsService] Unexpected response:', data?.result);
    return { slots: [], upcoming: [] };
  } catch (err) {
    console.error('[slotsService] Error fetching outlet slots:', err);
    return { slots: [], upcoming: [] };
  }
}

export function flattenSlots(apiSlots, bookable = true) {
  const flat = [];
  (apiSlots || []).forEach(professional => {
    if (!isAllowedSpecialty(professional)) return;
    const style = getSpecialtyStyle(professional.specialty_name);
    if (!style) return;
    (professional.available_slots || []).forEach(slot => {
      flat.push({
        id: slot.id,
        date: slot.date,
        init: slot.init_str,
        end: slot.end_str,
        bookable,
        professional: {
          id: professional.professional_id,
          name: professional.professional_name,
          photo: professional.professional_photo,
        },
        specialty: {
          id: professional.specialty_id,
          name: professional.specialty_name,
          emoji: style.emoji,
          color: style.color,
          accent: style.accent,
          durationId: style.durationId,
        },
      });
    });
  });
  flat.sort((a, b) => {
    if (a.date !== b.date) return a.date.localeCompare(b.date);
    return a.init.localeCompare(b.init);
  });
  return flat;
}

// "09:00" → "9:00 AM".
export function formatTime(timeStr) {
  if (!timeStr) return '';
  const [h, m] = timeStr.split(':').map(Number);
  const ampm = h >= 12 ? 'PM' : 'AM';
  const hour12 = h % 12 || 12;
  return `${hour12}:${String(m).padStart(2, '0')} ${ampm}`;
}

// Etiqueta humana de un día: Hoy / Mañana / "miércoles 5 jun".
export function formatDateLabel(dateStr) {
  const [y, mo, d] = dateStr.split('-').map(Number);
  const date = new Date(y, mo - 1, d);
  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  if (date.toDateString() === today.toDateString()) return 'Hoy';
  if (date.toDateString() === tomorrow.toDateString()) return 'Mañana';

  return date.toLocaleDateString('es-MX', { weekday: 'long', day: 'numeric', month: 'short' });
}
